import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Curiousthanks() {
  return (
    <section className="curious_thanks p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto order-2 order-md-1 mt-3 mt-md-0"
          >
            <StaticImage
              src="../../images/thanks/curious.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={655}
              height={445}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1 order-1 order-md-2"
          >
            <h2>
              Curious to know, <span>what happens next?</span>
            </h2>
            <p>
              Now just sit back and one of our consultants will take a look at
              your submission and will get in touch with you to discuss your
              project in more detail.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Curiousthanks;
